import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {ViewportScroller} from '@angular/common';
import {FooterDataService} from './footer-data.service';
import {BusyService} from '../../services/busy.service';
import {ToastrService} from 'ngx-toastr';
import {AuthService} from '../../../../../firebase/src/lib/services/auth.service';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
    url = window.location.host;
    text = 'About anima';
    year = new Date().getFullYear();

    constructor(
        private router: Router,
        private viewportScroller: ViewportScroller,
        private service: FooterDataService,
        private busy: BusyService,
        private toastr: ToastrService,
        public auth: AuthService,
    ) {
    }

    ngOnInit(): void {
    }

    approveGdpr() {
        // localStorage.setItem('gdprApproved', 'true');
    }

    get gdprApproved() {
        return true;
        // return localStorage.getItem('gdprApproved') || false;
    }

    goTo(route, fragment) {
        this.router.navigate([route])
            .then(() => {
                this.viewportScroller.scrollToAnchor(fragment);
            });
    }

    unsubscribe() {
        this.busy.setState(true);
        this.service.cancelSubscription()
            .subscribe(() => {
                this.busy.setState(false);
                this.toastr.success('Unsubscribed successfully');
            }, () => {
                this.busy.setState(false);
            });
    }

    get isSubscribed() {
        return this.auth.userState?.subscription?.activated;
    }

}
